/* @flow */
import * as React from 'react';
import { css, names } from 'linaria';

import Colors from '../../constants/Colors';

export default function TextInput({
  placeholder,
  className,
  ...props
}: {
  placeholder?: string,
  className?: string,
}) {
  return (
    <input
      type="text"
      placeholder={placeholder}
      className={names(Styles.Input, className)}
      {...props}
    />
  );
}

export const Styles = {
  Input: css`
    border: 1px solid rgb(230, 230, 230);
    border-radius: 5px;
    box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    box-sizing: border-box;
    display: block;
    font-size: 18px;
    height: 60px;
    padding-left: 24px;
    padding-right: 24px;
    width: 100%;
    background-color: #fefeff;
    &:focus {
      background-color: #fff;
      outline: none;
    }
    &::placeholder {
      color: ${Colors.opacity('#272936', 0.25)};
    }
  `,
};



// WEBPACK FOOTER //
// ./src/ui/components/core/TextInput.js